export default __webpack_public_path__ + "static/media/dep3_4.78850ade.png";